module.exports = __webpack_public_path__ + "media/images/Icône hébergement-3dbeea5925f79b9b8a1141525a40308d.svg";